// const isProduction = false;
const isProduction = true;

export { isProduction };

export const getViewerUrl = (studyInstanceUID, orthancStudyId) => {
    // Get OHIF viewer URL from config or environment variable
    const ohifBaseUrl = window.location.origin + '/orthanc/ohif';
    
    // Use study_instance_uid if available, otherwise use orthanc_study_id
    if (studyInstanceUID) {
      return `${ohifBaseUrl}/viewer?StudyInstanceUIDs=${studyInstanceUID}`;
    } else if (orthancStudyId) {
      // If only orthanc_study_id is available, use it
      return `${ohifBaseUrl}/viewer?StudyInstanceUIDs=${orthancStudyId}`;
    }
    return null;
  };